import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d9q2ruee3oq4jqumtfm0';

const testimonials = [
  {
    name: '张小明',
    role: '资深省钱达人',
    content: '自从关注了福利吧，每个月至少省下500块钱。以前总是错过各种优惠活动，现在每天打开福利吧就能看到最新福利，太方便了！',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20professional%20portrait%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20simple%20headshot%20photography%2C%20warm%20natural%20lighting%2C%20casual%20business%20attire&width=100&height=100&seq=avatar-user-01&orientation=squarish',
  },
  {
    name: '李晓红',
    role: '全职妈妈',
    content: '作为一个精打细算的全职妈妈，福利吧就是我的省钱神器。从宝宝用品到家庭日用品，每次都能找到最划算的购买方案。推荐给所有的妈妈们！',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20warm%20portrait%2C%20kind%20smile%2C%20clean%20white%20background%2C%20simple%20headshot%20photography%2C%20soft%20natural%20lighting%2C%20casual%20style&width=100&height=100&seq=avatar-user-02&orientation=squarish',
  },
  {
    name: '王大力',
    role: '数码爱好者',
    content: '数码产品价格波动大，稍不注意就买贵了。福利吧的限时秒杀频道帮我抢到了好几次超低价，上次的小米手环比我同事便宜了100多！',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20in%20his%2020s%20portrait%2C%20confident%20expression%2C%20clean%20white%20background%2C%20simple%20headshot%20photography%2C%20warm%20studio%20lighting%2C%20modern%20casual%20look&width=100&height=100&seq=avatar-user-03&orientation=squarish',
  },
];

const faqs = [
  {
    q: '福利吧的福利信息从哪里来？',
    a: '福利吧的编辑团队每天从各大电商平台、品牌官方渠道、社交媒体等来源人工筛选和核实福利信息，确保每一条福利都是真实有效的。我们也会与部分品牌合作，为用户争取独家福利。',
  },
  {
    q: '福利吧是否收费？',
    a: '福利吧完全免费！我们的使命是帮助用户省钱，不会向用户收取任何费用。你可以在福利吧自由浏览所有福利信息，订阅新闻简报也完全免费。',
  },
  {
    q: '如何第一时间获取最新福利？',
    a: '你可以通过以下方式获取最新福利：1) 订阅福利吧新闻简报，每日推送至邮箱；2) 关注福利吧微信公众号；3) 将福利吧加入浏览器收藏夹，每日访问。建议多种方式结合，不错过任何好福利。',
  },
  {
    q: '福利信息的更新频率是怎样的？',
    a: '福利吧编辑团队每日更新福利信息，通常在每天早上9点和下午3点进行两轮集中更新。限时秒杀和紧急福利会实时更新，确保用户第一时间看到。',
  },
  {
    q: '如果发现福利信息有误怎么办？',
    a: '我们非常重视信息的准确性。如果你发现任何福利信息有误或已过期，欢迎通过联系方式告诉我们，我们会在核实后立即修正。你的反馈是我们进步的动力！',
  },
];

export default function AboutPage() {
  const [contactStatus, setContactStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [contactMsg, setContactMsg] = useState('');

  const handleContact = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('company_alt') as string | null;
    if (honeypot && honeypot.trim()) {
      setContactStatus('success');
      setContactMsg('消息已发送，我们会尽快回复您！');
      return;
    }

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'company_alt' && value) {
          params.append(key, value.toString());
        }
      });

      const response = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText) as Record<string, unknown>; } catch { parsed = null; }

      if (response.ok && parsed && parsed.code === 'OK') {
        setContactStatus('success');
        setContactMsg('消息已发送，我们会尽快回复您！');
        form.reset();
      } else {
        const meta = (parsed?.meta as Record<string, string>) || {};
        const serverMsg = meta?.message || (parsed?.message as string) || '发送失败，请稍后重试';
        setContactStatus('error');
        setContactMsg(serverMsg);
      }
    } catch {
      setContactStatus('error');
      setContactMsg('网络错误，请稍后重试');
    }
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="关于我们 - 福利吧"
        description="福利吧是专为爱好优惠的用户打造的福利聚合平台。了解福利吧的品牌故事、团队使命、用户口碑和联系方式，加入省钱大家庭。"
        keywords="福利吧,关于我们,品牌介绍,联系方式,用户口碑"
        canonicalUrl="https://fuliba.com/about"
        breadcrumbs={[
          { name: '首页', url: 'https://fuliba.com/' },
          { name: '关于我们', url: 'https://fuliba.com/about' },
        ]}
      />

      <Navbar />

      <main className="pt-20 pb-14 min-h-screen bg-background-50">
        {/* Breadcrumb */}
        <div className="w-full px-4 md:px-6 mb-8">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
            <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-900 font-medium">关于我们</span>
          </nav>
        </div>

        {/* Hero */}
        <section className="w-full px-4 md:px-6 mb-16">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-3xl md:text-5xl font-bold font-heading text-foreground-950 mb-6">
              关于<span className="text-primary-500">福利吧</span>
            </h1>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
              福利吧诞生于2024年，由一群热爱找优惠、喜欢分享的年轻人创立。
              我们的使命很简单：让每一个用户都能花最少的钱，买到最值的东西。
              我们相信，省钱不是吝啬，而是一种聪明的生活态度。
            </p>
          </div>
        </section>

        {/* Stats */}
        <section className="w-full px-4 md:px-6 mb-16">
          <div className="max-w-4xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { value: '50万+', label: '活跃用户', icon: 'ri-user-star-line', color: 'text-primary-500' },
              { value: '10,000+', label: '每日福利', icon: 'ri-gift-line', color: 'text-accent-500' },
              { value: '500万+', label: '累计省钱（元）', icon: 'ri-money-cny-circle-line', color: 'text-secondary-600' },
              { value: '99.7%', label: '信息准确率', icon: 'ri-shield-check-line', color: 'text-accent-600' },
            ].map((stat) => (
              <div key={stat.label} className="text-center p-5 bg-background-100 rounded-xl">
                <i className={`${stat.icon} text-2xl ${stat.color} mb-2`}></i>
                <div className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">{stat.value}</div>
                <div className="text-foreground-600 text-xs mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Mission */}
        <section className="w-full px-4 md:px-6 mb-16">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="p-6 bg-background-100 rounded-xl text-center">
                <div className="w-12 h-12 mx-auto mb-3 bg-primary-100 rounded-full flex items-center justify-center">
                  <i className="ri-eye-line text-xl text-primary-600"></i>
                </div>
                <h3 className="font-bold font-heading text-foreground-900 text-base mb-2">我们的愿景</h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  成为中国最值得信赖的福利聚合平台，让每一位用户都能轻松获取全网最优福利信息，享受聪明消费的乐趣。
                </p>
              </div>
              <div className="p-6 bg-background-100 rounded-xl text-center">
                <div className="w-12 h-12 mx-auto mb-3 bg-accent-100 rounded-full flex items-center justify-center">
                  <i className="ri-heart-line text-xl text-accent-600"></i>
                </div>
                <h3 className="font-bold font-heading text-foreground-900 text-base mb-2">我们的价值观</h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  真实第一：每一条福利信息都经过人工核实；用户至上：始终站在用户角度思考；开放共享：让省钱的信息自由流动。
                </p>
              </div>
              <div className="p-6 bg-background-100 rounded-xl text-center">
                <div className="w-12 h-12 mx-auto mb-3 bg-secondary-100 rounded-full flex items-center justify-center">
                  <i className="ri-team-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="font-bold font-heading text-foreground-900 text-base mb-2">我们的团队</h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  由资深购物达人、数据分析师和产品设计师组成的专业团队，专注挖掘全网优质福利，用专业能力为用户创造价值。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="w-full px-4 md:px-6 mb-16 bg-background-100 py-14 md:py-20">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
                用户口碑
              </h2>
              <p className="text-foreground-600 text-sm mt-2">听听我们的用户怎么说</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {testimonials.map((t) => (
                <div key={t.name} className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                      <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-semibold text-foreground-900 text-sm">{t.name}</div>
                      <div className="text-foreground-500 text-xs">{t.role}</div>
                    </div>
                  </div>
                  <p className="text-foreground-600 text-sm leading-relaxed">{t.content}</p>
                  <div className="flex items-center gap-0.5 mt-3 text-secondary-500">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="w-full px-4 md:px-6 mb-16">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
                联系我们
              </h2>
              <p className="text-foreground-600 text-sm mt-2">有任何问题或建议，欢迎随时联系我们</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-5">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-mail-line text-lg text-primary-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-foreground-900 text-sm">电子邮件</h4>
                    <p className="text-foreground-600 text-sm">contact@fuliba.com</p>
                    <p className="text-foreground-500 text-xs mt-0.5">工作日24小时内回复</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-accent-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-wechat-line text-lg text-accent-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-foreground-900 text-sm">微信公众号</h4>
                    <p className="text-foreground-600 text-sm">福利吧</p>
                    <p className="text-foreground-500 text-xs mt-0.5">每日推送最新福利资讯</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-secondary-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-smartphone-line text-lg text-secondary-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-foreground-900 text-sm">小程序</h4>
                    <p className="text-foreground-600 text-sm">福利吧精选</p>
                    <p className="text-foreground-500 text-xs mt-0.5">微信搜索即可使用</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-foreground-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-time-line text-lg text-foreground-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-foreground-900 text-sm">工作时间</h4>
                    <p className="text-foreground-600 text-sm">周一至周五 9:00 - 18:00</p>
                    <p className="text-foreground-500 text-xs mt-0.5">法定节假日休息</p>
                  </div>
                </div>
              </div>

              <div>
                <form onSubmit={handleContact} data-readdy-form="true" className="bg-background-100 rounded-xl p-5 space-y-4">
                  <input
                    type="text"
                    name="company_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="spam-field"
                  />
                  <div>
                    <label className="block text-foreground-700 text-sm font-medium mb-1.5">
                      你的名字 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-foreground-900 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入你的名字"
                    />
                  </div>
                  <div>
                    <label className="block text-foreground-700 text-sm font-medium mb-1.5">
                      邮箱地址 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-foreground-900 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入你的邮箱"
                    />
                  </div>
                  <div>
                    <label className="block text-foreground-700 text-sm font-medium mb-1.5">
                      留言内容 <span className="text-primary-500">*</span>
                    </label>
                    <textarea
                      name="message"
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-foreground-900 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                      placeholder="请输入你想说的话（500字以内）"
                    ></textarea>
                    <p className="text-foreground-400 text-xs mt-1">最多500个字符</p>
                  </div>
                  <button
                    type="submit"
                    className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                  >
                    发送消息
                  </button>
                  {contactStatus !== 'idle' && (
                    <p className={`text-sm text-center ${contactStatus === 'success' ? 'text-accent-600' : 'text-primary-600'}`}>
                      {contactMsg}
                    </p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="w-full px-4 md:px-6 bg-background-100 py-14 md:py-20">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
                常见问题
              </h2>
              <p className="text-foreground-600 text-sm mt-2">关于福利吧的常见问题解答</p>
            </div>
            <div className="space-y-3">
              {faqs.map((faq, i) => (
                <details key={i} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                    <h3 className="font-medium text-foreground-900 text-sm pr-4">{faq.q}</h3>
                    <i className="ri-add-line text-foreground-500 group-open:hidden flex-shrink-0"></i>
                    <i className="ri-subtract-line text-primary-500 hidden group-open:block flex-shrink-0"></i>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: '关于福利吧',
        description: '福利吧是专为爱好优惠的用户打造的福利聚合平台。',
        url: 'https://fuliba.com/about',
        about: {
          '@type': 'Organization',
          name: '福利吧',
          url: 'https://fuliba.com',
          description: '每日精选福利汇聚，好物好价不错过',
          contactPoint: {
            '@type': 'ContactPoint',
            email: 'contact@fuliba.com',
            contactType: 'customer service',
            availableLanguage: ['Chinese'],
          },
        },
      })}} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map(faq => ({
          '@type': 'Question',
          name: faq.q,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.a,
          },
        })),
      })}} />
    </>
  );
}